<template>
  <div
    v-if="stepInfo"
    class="work-step"
    style="overflow-y: auto; overflow-x: hidden;
    padding: 0 1rem;"
  >
    <el-row
      :gutter="24"
      class="d-flex align-items-center justify-content-between flex-wrap"
    >
      <el-col :span="12" class="d-flex justify-content-between"
        style="padding-top:10px;">
        <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
          创建时间:
        </div>
        <div
          class="brief-info-content none-width flex-grow-1"
          style="text-align: right"
          :class="{'dark':skinType}"
        >
          {{ stepInfo.F_CreateDate }}
        </div>
      </el-col>
      <el-col :span="12" class="d-flex justify-content-between"
        style="padding-top:10px;">
        <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
          创建用户:
        </div>
        <div
          class="brief-info-content none-width flex-grow-1"
          style="text-align: right"
          :class="{'dark':skinType}"
        >
          {{ stepInfo.F_CreateUserName }}
        </div>
      </el-col>
      <el-col :span="12" class="d-flex justify-content-between"
        style="padding-top:10px;">
        <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
          处理信息:
        </div>
        <div
          class="brief-info-content none-width flex-grow-1"
          style="text-align: right"
          :class="{'dark':skinType}"
        >
          {{ stepInfo.F_Description }}
        </div>
      </el-col>
      <el-col :span="12" class="d-flex justify-content-between"
        style="padding-top:10px;">
        <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
          当前节点:
        </div>
        <div
          class="brief-info-content none-width flex-grow-1"
          style="text-align: right"
          :class="{'dark':skinType}"
        >
          {{ stepInfo.F_NodeName }}
        </div>
      </el-col>
       <el-col :span="24" class="d-flex justify-content-between"
        style="padding-top:10px;">
        <div class="brief-info-title" :class="{'dark':skinType}" style="text-align: right">
          图片详情:
        </div>
        <div
          class="brief-info-content none-width flex-grow-1"
          style="text-align: left"
          :class="{'dark':skinType}"
           v-for="(item,t) in imageList" :key="t"
        >
            <img class="img-div" :src="item">
        </div>
      </el-col>
    </el-row>
  </div>
  <NoDataTemporarily v-else></NoDataTemporarily>
</template>
<script>
import { BASE_URL } from '@/utils/request/request';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';

export default {
  name: 'work-step',
  components: {
    NoDataTemporarily,
  },
  props: {
    stepInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    imageList() {
      if (!this.stepInfo || !this.stepInfo.F_UploadUrl) {
        return [];
      }
      const imgs = this.stepInfo.F_UploadUrl.split('|').map((url) => `${BASE_URL}${url}`);
      return imgs;
    },
    // contentList() {
    //   if (!this.stepInfo || !this.stepInfo.ContentList) {
    //     return [];
    //   }
    //   return this.stepInfo.ContentList.filter(
    //     (content) => content.Name.indexOf('图片') < 0,
    //   );
    // },
  },
};
</script>
<style scoped>
.brief-info-title {
  color: #999999;
}
.brief-info-content {
  color: #111111;
}
.brief-info-content.dark{
  color: #EEEEEE;
}
.step-name,
.step-time,
.step-info {
  text-align: left;
}
.step-images + .step-images {
  margin-top: 12px;
}
.manage-button {
  margin-left: 10rem;
}
.img-div{
  width: 220px;
  padding-left: 10px;
}
.brief-info-title.dark {
    color:white;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  /* color: red; */
  /* color: #999999; */
}

.brief-info-content {
  color: #111111;
}
.brief-info-content.dark{
  font-size: 15px;
  text-align: center;
  margin: auto;
  color: #EEEEEE;
}
</style>
